export const PLUS_QUOTE_EVENT_NAME = 'QuoteFormSubmissionForPlusProduct'
export const DTC_QUOTE_EVENT_NAME = 'QuoteFormSubmissionForDTCProduct'
export const MISSING_SKU_ERROR =
  'Quote request unsuccessful. Please try again later or contact our support team at support@noissue.co for assistance.'
